import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f16f2a84")

_pushScopeId("data-v-f16f2a84")
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col text-lg"
}
const _hoisted_2 = {
  key: 0,
  class: "my-0 text-xs"
}
const _hoisted_3 = {
  key: 1,
  class: "flex justify-end"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
    return (_openBlock(), _createBlock("div", {
      key: option.label,
      onClick: () => _ctx.onClick(option.label),
      class: `flex text-primary cursor-pointer bg-white items-center p-5 border-solid border-2 rounded-xl w-full justify-between ${
      option.value === _ctx.currentAnswer ? 'border-accent' : 'border-secondary'
    }`
    }, [
      (option.label)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("span", {
              innerHTML: option.label
            }, null, 8, ["innerHTML"]),
            (option.subtitle)
              ? (_openBlock(), _createBlock("p", _hoisted_2, [
                  _createVNode("span", {
                    innerHTML: option.subtitle
                  }, null, 8, ["innerHTML"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (option.image)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("img", {
              src: option.image,
              alt: option.label || '',
              class: "flex image"
            }, null, 8, ["src", "alt"])
          ]))
        : _createCommentVNode("", true)
    ], 10, ["onClick"]))
  }), 128))
})